import React from "react";
import Col from "react-bootstrap/Col";

export default class Footer extends React.Component {
  render() {
    return (
      <footer className="text-center">
        <Col lg={12}>
          <p className="mt-5 mb-5">© 2019–2025 TrueFingerprints LLC, dba Personnelgraph. All rights reserved.</p>
        </Col>
      </footer>
    );
  }
}
